module.exports = __webpack_public_path__ + "static/assets/988503110cb2f044783567fbaed81750.svg";